import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { taxReportsContract } from "@common/contracts/tax-reports.contract";
import { Form1099ReportFilters } from "@common/schemas/domains/tax/form1099-report.schema";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { useScope } from "@state/scopeContext.lib";
import { queryClient } from "../queryClient";

const taxReportsClient = getBackendAPIClient(taxReportsContract);
const taxReportsBlobClient = getBackendAPIClient(taxReportsContract, "blob");

export const form1099NecReportQueryKey = "form-1099-nec-report";

interface Form1099NecReportParams {
    taxYear: number;
    entityId: number | undefined;
    filters: Form1099ReportFilters | undefined;
}

export function useForm1099NecReportQuery({
    taxYear,
    entityId,
    filters,
}: Form1099NecReportParams) {
    const { workspaceId } = useScope();

    return useQuery({
        queryKey: [
            form1099NecReportQueryKey,
            workspaceId,
            taxYear,
            entityId,
            filters,
        ],
        enabled:
            Boolean(workspaceId) &&
            entityId !== undefined &&
            filters !== undefined,
        queryFn: async () => {
            if (!workspaceId) {
                return undefined;
            }
            const response = await taxReportsClient.get1099NecReport({
                query: { workspaceId, taxYear, entityId, ...filters },
            });
            return response.body;
        },
        placeholderData: keepPreviousData,
        retry: false,
    });
}

export function invalidateForm1099NecReport(workspaceId: string) {
    return queryClient.invalidateQueries({
        queryKey: [form1099NecReportQueryKey, workspaceId],
    });
}

export async function downloadForm1099NecTrack1099Csv({
    workspaceId,
    taxYear,
    entityId,
}: {
    workspaceId: string;
    taxYear: number;
    entityId: number;
}) {
    return await taxReportsBlobClient.get1099NecTrack1099Csv({
        query: { workspaceId, taxYear, entityId },
    });
}
